import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getAnalyticsSurveyDataAction = createAsyncThunk(
    'no-of-surveys-count',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/no-of-surveys-count?s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getAnalyticsSurveyDataSlice = createSlice({
    name: 'no-of-surveys-count',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAnalyticsSurveyDataAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAnalyticsSurveyDataAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getAnalyticsSurveyDataAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },
})


export const getAnalyticsSurveyDataReducer = getAnalyticsSurveyDataSlice.reducer